import { useCallback } from 'react';
import { DailyLedger } from '../modules/parties/types';
// import { DailyLedger } from '../modules/parties/pages/dailyLedger/types/dailyLedger';

export const useBalanceCalculator = () => {
  const calculateRunningBalance = useCallback((ledgers:DailyLedger[]) => {
    if (!ledgers || !Array.isArray(ledgers)) return [];
    
    let runningBalance = 0;
    
    return ledgers.map((ledger, index) => {
      const credit = ledger.credit || 0;
      const debit = ledger.debit || 0;
      
      // Balance = Previous Balance + Debit - Credit
      runningBalance = runningBalance + debit - credit;
      
      return {
        ...ledger,
        balance: runningBalance
      };
    });
  }, []);

  return { calculateRunningBalance };
};